import { CloudProviders } from '@ariksa/cloud-account';
import {
  Days,
  ReportFormat,
  VulnerabilityReportSubTypes,
} from '@ariksa/reporting';
import {
  Months,
  ReportingTargets,
  ReportTypes,
  ScheduleInterval,
} from '@ariksa/reporting';
import {
  AdminNotificationPreference,
  CloudProvider,
} from '@ariksa/reporting/api';
import { filter, map } from 'lodash';

import { toTitleCase } from 'utils/string';

export const frequencyOptions = [
  { label: 'Daily', value: ScheduleInterval.Daily },
  { label: 'Weekly', value: ScheduleInterval.Weekly },
  { label: 'Monthly', value: ScheduleInterval.Monthly },
  { label: 'Yearly', value: ScheduleInterval.Yearly },
];

export const months = [
  Months.January,
  Months.February,
  Months.March,
  Months.April,
  Months.May,
  Months.June,
  Months.July,
  Months.August,
  Months.September,
  Months.October,
  Months.November,
  Months.December,
];

export const reportTypeOptions = map(
  filter(ReportTypes, o => o !== ReportTypes.MachineAccessReview),
  o => ({
    label: toTitleCase(o),
    value: o,
  }),
);

export const weekNumberOptions = [
  { label: '1st', value: 1 },
  { label: '2nd', value: 2 },
  { label: '3rd', value: 3 },
  { label: '4th', value: 4 },
];

export const weekDaysOptions = [
  { label: 'Monday', value: Days.Monday },
  { label: 'Tuesday', value: Days.Tuesday },
  { label: 'Wednesday', value: Days.Wednesday },
  { label: 'Thursday', value: Days.Thursday },
  { label: 'Friday', value: Days.Friday },
  { label: 'Saturday', value: Days.Saturday },
  { label: 'Sunday', value: Days.Sunday },
];

export const targetOptions = [
  { label: 'Email', value: ReportingTargets.Email },
  { label: 'SIEM', value: ReportingTargets.ElasticSearch },
];

export const reportFormatOptions = [
  { label: 'CSV', value: ReportFormat.Csv },
  { label: 'PDF', value: ReportFormat.Pdf },
  { label: 'None', value: undefined },
];

export const cloudProviderMapping = {
  [CloudProviders.Aws]: CloudProvider.Aws,
  [CloudProviders.Azure]: CloudProvider.Azure,
  [CloudProviders.AzureAd]: CloudProvider.AzureAd,
  [CloudProviders.Gcp]: CloudProvider.Gcp,
  [CloudProviders.Okta]: CloudProvider.Okta,
  [CloudProviders.Snowflake]: CloudProvider.Snowflake,
  [CloudProviders.GoogleWorkspace]: CloudProvider.GoogleWorkspace,
  [CloudProviders.Gitlab]: CloudProvider.GitLab,
  [CloudProviders.Github]: CloudProvider.GitHub,
  [CloudProviders.Bitbucket]: CloudProvider.Bitbucket,
  [CloudProvider.Aws]: CloudProviders.Aws,
  [CloudProvider.Azure]: CloudProviders.Azure,
  [CloudProvider.AzureAd]: CloudProviders.AzureAd,
  [CloudProvider.Gcp]: CloudProviders.Gcp,
  [CloudProvider.Okta]: CloudProviders.Okta,
  [CloudProvider.Snowflake]: CloudProviders.Snowflake,
  [CloudProvider.GoogleWorkspace]: CloudProviders.GoogleWorkspace,
  [CloudProvider.GitLab]: CloudProviders.Gitlab,
  [CloudProvider.GitHub]: CloudProviders.Github,
  [CloudProvider.Bitbucket]: CloudProviders.Bitbucket,
};

export const adminPreferenceOptions = [
  {
    label: 'Sending a report fails',
    value: AdminNotificationPreference.FailuresOnly,
  },
  {
    label: 'Sending a report (success or failure)',
    value: AdminNotificationPreference.All,
  },
];

export const vulnerabilitySubTypeOptions = [
  {
    label: 'Vulnerabilities with Internet access and known public exploits',
    subLabel:
      'I want to focus on patching what’s network accessible and exploitable from outside',
    value: VulnerabilityReportSubTypes.InternetExploitable,
  },
  {
    label: 'Vulnerabilities with known public exploits',
    subLabel:
      'I want to focus on patching all resources with known public exploits, regardless of network access',
    value: VulnerabilityReportSubTypes.Exploitable,
  },
  {
    label: 'All vulnerabilities',
    subLabel:
      'I want to know all my vulnerabilities, regardless of exploitability and reachability',
    value: VulnerabilityReportSubTypes.All,
  },
];
